import { FacilityListParams } from '@gyym/sdk'
import {
  composeServerProps,
  gyymPrefetch,
  withGyymAuth,
  withGyymSSR,
} from '@gyym/sdk-next'
import React from 'react'

import { FacilitySearchView } from '@/components/Views/FacilitySearchView'
import {
  searchQueryConverter,
  searchSegments,
  shouldPrefetchFacilitySearch,
} from '@/modules/FacilitySearch'

type SearchPageProps = {
  query: FacilityListParams
  view: 'map' | null
}

export const getServerSideProps = composeServerProps(
  withGyymAuth(),
  withGyymSSR(async (ctx, client) => {
    const { prefectureSlug, cityCode, activitySlug, ...rest } = ctx.query ?? {}

    const segments = [
      prefectureSlug,
      `${searchSegments.CITY_CODE_PREFIX}${cityCode}`,
      activitySlug,
    ] as [string, string, string]

    const resources = await searchSegments.fetchResources(segments, client)

    if (resources.notFound) {
      return {
        notFound: true,
      }
    }

    const searchQuery: FacilityListParams = {
      ...searchQueryConverter.fromQuery(rest),
      ...searchQueryConverter.fromPathSegments(segments),
    }

    return {
      cache: [
        ...resources.cache,
        ...(shouldPrefetchFacilitySearch(searchQuery)
          ? [gyymPrefetch(client.user.facilities.list, searchQuery)]
          : []),
      ],
      props: {
        view: ctx.query.view === 'map' ? 'map' : null,
        query: searchQuery,
      },
    }
  }),
)

/**
 * Search page component
 */
const SearchPage = (props: SearchPageProps) => {
  const isMapView = props.view === 'map'

  return (
    <FacilitySearchView.SearchProvider
      value={{
        isMapView,
        searchParams: props.query,
      }}
    >
      <FacilitySearchView.Content />
    </FacilitySearchView.SearchProvider>
  )
}

export default SearchPage
